import { LitElement, css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import { tokens } from '../../../theme/tokens.css';
import { uiState as uiStateProxy } from '../../../UIState';
import { bindValtio } from '../../../ValtioController';

@customElement('players-online')
export class PlayersOnline extends LitElement {
  static override styles = [
    tokens,
    css`
      /* Placed by airmash-lobby's top row. */
      :host {
        display: block;
        white-space: nowrap;
        text-align: center;
        font-family: var(--font-family);
        /* Legacy's 12px. */
        font-size: var(--font-size-sm);
        text-shadow: var(--shadow-text);
        color: var(--color-text-tooltip);
        cursor: default;
        pointer-events: none;
        -webkit-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: transparent;
      }

      .count {
        display: inline-block;
        color: var(--color-text-white);
        background-color: var(--color-bg-chip);
        border-radius: var(--radius-md);
        padding: 3px 6px;
        margin: 0 8px;
        font-weight: bold;
      }
    `,
  ];

  private uiState = bindValtio(this, uiStateProxy);

  private getPlayerCount(): number {
    let count = 0;
    for (const region of this.uiState.regions) {
      for (const game of region.games) {
        if (game.players != null) {
          count += game.players;
        }
        if (game.bots != null) {
          count -= game.bots;
        }
      }
    }
    // Clamp against bad server data (more bots reported than players).
    return Math.max(0, count);
  }

  override render() {
    if (this.uiState.regions.length === 0) {
      return nothing;
    }

    const playerCount = this.getPlayerCount();
    const plural = playerCount !== 1 ? 's' : '';

    return html`<span class="count">${playerCount}</span>player${plural} online`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'players-online': PlayersOnline;
  }
}
